/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Component: `.accordion`
 * This toggles aria-expanded state, which CSS, in-turn
 * uses to display or hide content using the `+` selector
 * 
 * NOTE: this functionality is global and also used in the footer
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

function accordionToggleHandler($$toggles, $toggle, $expandAll, $collapseAll) {
	return function(/* event */) {
		const expanded = $toggle.getAttribute('aria-expanded') === 'true'
		$toggle.setAttribute('aria-expanded', !expanded)
		if ($expandAll && $collapseAll) {
			if (expanded) {
				$expandAll.removeAttribute('aria-expanded')
				$expandAll.disabled = false
				if (_.map($$toggles, $toggle => $toggle.getAttribute('aria-expanded')).indexOf('true') < 0) {
					$collapseAll.setAttribute('aria-expanded', 'false')
					$collapseAll.disabled = true
				}
			} else {
				$collapseAll.removeAttribute('aria-expanded')
				$collapseAll.disabled = false
				if (_.map($$toggles, $toggle => $toggle.getAttribute('aria-expanded')).indexOf('false') < 0) {
					$expandAll.setAttribute('aria-expanded', 'true')
					$expandAll.disabled = true
				}
			}
		}
	}
}

_.each(document.querySelectorAll('.accordion'), $accordion => {

	const $expandAll = $accordion.querySelector('.expand-all')
	const $collapseAll = $accordion.querySelector('.collapse-all')
	const $$toggles = $accordion.querySelectorAll('[aria-controls]')

	_.each($$toggles, $toggle => $toggle.addEventListener('click', accordionToggleHandler($$toggles, $toggle, $expandAll, $collapseAll)))

	if ($expandAll && $collapseAll) {
		$expandAll.addEventListener('click', function() {
			$expandAll.setAttribute('aria-expanded', 'true')
			$expandAll.disabled = true
			$collapseAll.removeAttribute('aria-expanded')
			$collapseAll.disabled = false
			_.each($$toggles, $toggle => $toggle.setAttribute('aria-expanded', 'true'))
		})
		$collapseAll.addEventListener('click', function() {
			$collapseAll.setAttribute('aria-expanded', 'false')
			$collapseAll.disabled = true
			$expandAll.removeAttribute('aria-expanded')
			$expandAll.disabled = false
			_.each($$toggles, $toggle => $toggle.setAttribute('aria-expanded', 'false'))
		})
	}

})
